import type { ParameterFormula } from './parameter-formulas';

/** One result row, as far as counting progress needs it. */
export interface ProgressDetail {
  result: string;
  /** A row with a formula is calculated from the others, never typed in. */
  parameter: { formula: ParameterFormula | null };
}

export interface ResultProgress {
  entered: number;
  total: number;
}

/**
 * How far through its results a report is — "6/8" on the worklist, the
 * dashboard queue and the patient record.
 *
 * The server's completion rule, so the lists and the entry screen agree: a
 * culture has one result, its outcome; any other report counts its measured
 * rows only. A calculated row's inputs are what someone enters, and counting it
 * would leave a report reading "7/8" with nothing left to type.
 */
export function reportProgress(report: {
  report_details: readonly ProgressDetail[];
  culture: { outcome: string | null } | null;
}): ResultProgress {
  if (report.culture) return { entered: report.culture.outcome === null ? 0 : 1, total: 1 };
  const measured = report.report_details.filter((detail) => detail.parameter.formula === null);
  return {
    entered: measured.filter((detail) => detail.result.trim() !== '').length,
    total: measured.length,
  };
}
